import { Link, Head, usePage, Deferred } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ColumnDef } from "@tanstack/react-table"
import { Plus } from "lucide-react"
import { FlashMessage } from '@/components/flash-message'
import { SortableHeader } from '@/components/sortable-header'
import { FilteredTable } from '@/components/ui/filtered-table'
import { Buyer } from '@/types/serializers'

interface Props {
  buyers: Buyer[]
  [key: string]: any
}

const columns: ColumnDef<Buyer>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => <SortableHeader column={column} title="Name" />,
    enableSorting: true,
    cell: ({ row }) => {
      const buyer = row.original
      return (
        <Link href={`/buyers/${buyer.id}`} className="hover:underline">
          {buyer.name}
        </Link>
      )
    }
  },
  {
    accessorKey: "code",
    header: ({ column }) => <SortableHeader column={column} title="Code" />,
    enableSorting: true,
  },
  {
    accessorKey: "sector",
    header: ({ column }) => <SortableHeader column={column} title="Sector" />,
  },
  {
    accessorKey: "region",
    header: "Region",
  },
  {
    accessorKey: "country",
    header: "Country",
  },
  {
    accessorKey: "state",
    header: "State",
  },
  {
    accessorKey: "city",
    header: "City",
  },
  {
    accessorKey: "salesforce_id",
    header: "Salesforce ID",
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const buyer = row.original
      return (
        <div className="flex items-center gap-2">
          <Link href={`/buyers/${buyer.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
          <Link href={`/buyers/${buyer.id}/edit`}>
            <Button variant="outline" size="sm">
              Edit
            </Button>
          </Link>
        </div>
      )
    },
  },
]

export default function Index() {
  const { buyers } = usePage<Props>().props

  return (
    <>
      <Head title="Buyers" />
        <div className="space-y-4 pt-4 px-6">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold">Buyers</h1>
          </div>
        </div>

        <FlashMessage />

        <div className="p-6">
          <Deferred data="buyers" fallback={<div>Loading...</div>}>
            <FilteredTable
              data={buyers}
              columns={columns}
              searchPlaceholder="Search buyers..."
            />
          </Deferred>
      </div>
    </>
  )
}
